<template>
    <register-layout v-on:submit="submit">
        <div class="tw-p-6">
            <div class="tw-text-xl tw-font-bold tw-col-span-2">{{$word.about_you}}:</div>


            <div class="tw-mt-3">
                <div class="tw-mb-1 tw-font-bold">{{$word.avatar}}
                    <span class="tw-font-bold tw-text-red-500">*</span>
                </div>
                <div class="tw-flex tw-items-center tw-space-x-2">
                    <v-select-avatar v-model="states.form.avatar" v-slot="{select,remove,thumbnail}">
                        <div class="tw-flex tw-items-center tw-space-x-2">
                            <img v-if="thumbnail" :src="thumbnail" class="tw-w-16 tw-h-16 tw-rounded tw-object-cover"
                                 alt="">
                            <div tabindex="0" v-on:click="() => select()"
                                 class="tw-cursor-pointer tw-rounded tw-bg-blue-500 tw-text-white tw-font-semibold tw-px-3 tw-py-1">
                                <span v-if="thumbnail">Change</span>
                                <span v-else>Select</span>
                                
                            </div>
                            <div v-if="thumbnail" title="Remove" tabindex="0" v-on:click="() => remove()"
                                 class="tw-cursor-pointer tw-rounded tw-bg-red-500 tw-text-white tw-font-semibold tw-px-3 tw-py-1">
                                <i class="fas fa-times"></i>
                            </div>
                        </div>
                    </v-select-avatar>
                </div>
                <div v-html="_.get(errors,'avatar.0')" class="tw-text-red-500 tw-mt-1"></div>
            </div>

            <div class="tw-mt-3">
                <div class="tw-mb-1 tw-font-bold">{{$word.name}}
                    <span class="tw-font-bold tw-text-red-500">*</span>
                </div>
                <input type="text" class=" form-input" v-model="states.form.name">
                <div v-html="_.get(errors,'name.0')" class="tw-text-red-500 tw-mt-1"></div>
            </div>


            <div class="tw-mt-3">
                <div class="tw-mb-1 tw-font-bold">
            
                    {{$word.username}}
                    <span class="tw-font-bold tw-text-red-500" id="inputIsRequiredSign">*</span>
                    <span id="usernameIsOk" style="display:none">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                    </span>
                </div>
                <input type="text" class=" form-input" id="usernameInput" @keyup="validateUsername" v-model="states.form.username">
                <div v-html="_.get(errors,'username.0')" id="usernameMsg" class="tw-text-red-500 tw-mt-1"></div>
            </div>

            <div class="tw-mt-3">
                <div class="tw-mb-1 tw-font-bold">{{$word.birth_date}}</div>
                <v-date-picker
                    input-class="form-input" name="dob" id="dob" v-model="states.form.dob" format="dd MMM yyyy"
                    :place-holder="$word.birthday_placeholder"
                />
                <div v-html="_.get(errors,'dob.0')" class="tw-text-red-500 tw-mt-1"></div>
            </div>

           
            

            <div class="tw-mt-3">
                <div class="tw-mb-1 tw-font-bold">{{$word.hometown}}</div>
                <v-select-home-town v-model="states.form.place"></v-select-home-town>
                <div v-html="_.get(errors,'place.0')" class="tw-text-red-500 tw-mt-1"></div>
            </div>
        </div>
    </register-layout>
</template>
<script>
    import store from './register-store'
    import RegisterLayout from './register-layout'

    export default {
        components: {RegisterLayout},
        data: v => ({
            states: store.states,
            errors: {},
        }),
        created() {
            this.store = store
        },
        methods: {
            submit() {
                store.states.loading = true
                let baseForm = store.composeForm();
                console.log(baseForm.avatar)
                let form = new FormData();

                _.forEach(baseForm, (value, key) => {
                   
                    if (value === true) {
                        form.append(key, 1)
                    } else if (value === false) {
                        form.append(key, 0)
                    } else if (_.isArray(value)) {
                        value.forEach(val => {
                            form.append(`${key}[]`, val)
                        })
                    } else {
                        if(value !== null && value !== 'null'){
                            form.append(key, value)
                        }
                    }
                });

                axios.post('/validate-register', form,{headers: {'Content-Type': 'multipart/form-data'}})
                    .then(() => {
                        this.errors = {}
                    })
                    .catch(err => {
                        err.response.status === 422 && (this.errors = err.response.data.errors)
                    })
                    .finally(() => {
                        store.states.loading = false
                        if (store.hasNoErrors(this.errors, ['name', 'avatar', 'dob','username'])) {
                            store.states.current_step++;
                        }
                    })
            },
            validateUsername(event){
                let user_name = event.target.value;
                axios.post('/validate-username', {'username':user_name})
                    .then((res) => {
                        let msg = res['data']['msg'];
                        let success = res['data']['success'];
                        if(success){
                            $("#usernameInput").css('borderColor','rgb(228, 228, 230)')
                            $("#usernameMsg").html(' ')
                            $("#usernameIsOk").show()
                            $("#inputIsRequiredSign").hide()
                        }else{
                            $("#usernameInput").css('borderColor','red')
                            $("#usernameMsg").html(msg)
                            $("#usernameIsOk").hide()
                            $("#inputIsRequiredSign").show()


                        }
                    });
                    
                   
            },
        },
    }
</script>
<style>
    .pointer {
        cursor: pointer;
    }
</style>
